module.exports = __webpack_public_path__ + "resource/img/image001Dark.d900969b.png";